import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
  Spinner,
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import * as Yup from "yup";
import { useFormik } from "formik";
import { loginRequest } from "../../store/actions";
import withRouter from "components/Common/withRouter";
import Footer from "components/VerticalLayout/Footer";
import profile from "assets/images/profile-img.png";
import logo from "assets/images/logo.svg";
import domLogo from "../../assets/images/logo_white.png";
import logoW from "../../assets/images/logo_white_seule.png";
import logoB from "../../assets/images/logo_black_seule.png";
import logoBlack from "../../assets/images/Logo-h-rvb.svg";
import background from "../../assets/images/guyane.png";
import Config from "config";
const Login = (props) => {
  const backUrl = Config.backOffice.url;
  const layout = localStorage.getItem("layoutMode");
  const loading = useSelector((state) => state.Login.loading);

  document.title = "Login | DOM COM INVEST";
  const dispatch = useDispatch();
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      login: "",
      password: "",
    },
    validationSchema: Yup.object({
      login: Yup.string().required("Please Enter Your login"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: (values) => {
      dispatch(loginRequest(values, props.router.navigate));
    },
  });

  const selectLoginState = (state) => state.Login;
  const LoginProperties = createSelector(selectLoginState, (login) => ({
    error: login.error,
  }));

  const { error } = useSelector(LoginProperties);
  return (
    <React.Fragment>
      <div
        style={{
          backgroundImage: `url(${background})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          width: "100vw",
          height: "100vh",
        }}
      >
        <div className="account-pages" style={{ paddingTop: "8em" }}>
          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="overflow-hidden">
                  <div className="bg-primary-subtle">
                    <Row>
                      <Col className="col-6">
                        <div className="p-4">
                          <h5 className="text-primary">Bienvenue</h5>
                          <p>Connectez vous pour continuer sur DomCom.</p>
                        </div>
                      </Col>
                      <Col className="col-5">
                        <img
                          src={layout === "dark" ? domLogo : logoBlack}
                          alt="logo"
                          className="img-fluid mt-4"
                        />
                      </Col>
                      <Col className="col-1">&nbsp;</Col>
                    </Row>
                  </div>
                  <CardBody className="pt-0">
                    <div>
                      <Link to="/" className="logo-light-element">
                        <div className="avatar-md profile-user-wid mb-4">
                          <span className="avatar-title rounded-circle bg-light">
                            <img
                              src={logo}
                              alt=""
                              className="rounded-circle"
                              height="34"
                            />
                          </span>
                        </div>
                      </Link>
                    </div>
                    <div className="p-2">
                      <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        {error ? <Alert color="danger">{error}</Alert> : null}
                        {/* {loading && (
                          <div className="text-center mb-3 d-flex align-items-center justify-content-center">
                            <Spinner color="primary" className="me-2" />
                            <span>Connexion en cours...</span>
                          </div>
                        )} */}
                        <div className="mb-3">
                          <Label className="form-label">Login</Label>
                          <Input
                            name="login"
                            id="login"
                            className="form-control"
                            placeholder="Login"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.login || ""}
                            invalid={
                              validation.touched.login &&
                              validation.errors.login
                                ? true
                                : false
                            }
                          />
                          {validation.touched.login &&
                          validation.errors.login ? (
                            <FormFeedback type="invalid">
                              {validation.errors.login}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <Label className="form-label">Password</Label>
                          <Input
                            id="keypass"
                            name="password"
                            value={validation.values.password || ""}
                            type="password"
                            placeholder="Mot de passe"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.password &&
                              validation.errors.password
                                ? true
                                : false
                            }
                          />
                          {validation.touched.password &&
                          validation.errors.password ? (
                            <FormFeedback type="invalid">
                              {validation.errors.password}
                            </FormFeedback>
                          ) : null}
                        </div>

                        {/* <div className="form-check">
                          <input type="checkbox" className="form-check-input" id="customControlInline" />
                          <label className="form-check-label" htmlFor="customControlInline">
                            Se souvenir de moi
                          </label>
                        </div> */}

                        <div className="mt-3 d-grid">
                          <button
                            className="btn btn-primary btn-block"
                            type="submit"
                            id="submit"
                            disabled={loading}
                          >
                            {loading ? "Connexion en cours" : "Se connecter"}
                          </button>
                        </div>

                        <div className="mt-4 text-center">
                          <Link
                            to={`${backUrl}/forgot-password`}
                            className="text-muted"
                          >
                            <i className="mdi mdi-lock me-1" />
                            Mot de passe oublié?
                          </Link>
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
